import { PayloadAction } from '@reduxjs/toolkit'
import { IActionRelationshipsRequest, RelationshipsTypes } from './types'
import { all, apply, put, takeLatest } from 'redux-saga/effects'
import { RelationshipsActions } from './index'
import relationshipsService, { RelationshipsData } from '../../services/relationships.service'
import { SnackbarActions, SnackBarMessageType } from '../snackbar'

export function* request(action: PayloadAction<IActionRelationshipsRequest>) {
    const { relationshipsSuccess, relationshipsFailure } = RelationshipsActions
    const { openSnackBar } = SnackbarActions
    try {
        const { cpfs, cnpjs, merge } = action.payload
        const data: RelationshipsData = yield apply(
            relationshipsService,
            relationshipsService.getRelationships,
            [cpfs, cnpjs]
        )
        yield put(relationshipsSuccess({ data, merge }))   // <- adiciona merge aqui
    } catch (err: any) {
        yield put(relationshipsFailure())
        yield put(openSnackBar({
            title: 'Erro.',
            type: SnackBarMessageType.ERROR,
            message: 'Não foi possível carregar os vínculos.'
        }))
    }
}

const relationshipsSaga = function* () {
    yield all([
        takeLatest(RelationshipsTypes.RELATIONSHIPS_REQUEST, request),
    ])
}

export default relationshipsSaga
